import type React from 'react';

import { useHomepagePageData } from '#src/app/pages/homepage/pageContext';
import { TopImpactStoriesMobile, TopImpactStoriesMobileProvider } from '#src/app/pages/homepage/shared/components';

import { SapCtas } from './components/SapCtas';
import { TitleAndTagline } from './components/TitleAndTagline';
import { TopImpactStoriesDesktop } from './components/TopImpactStoriesDesktop';

export const HeroSection: React.FC = () => {
	const {
		data: { topImpactStories },
	} = useHomepagePageData();

	return (
		<section data-testid="homepage-hero-section" className="text-typography-strong relative">
			<div className="relative z-10 container pt-6 md:pt-11 lg:pt-15">
				<div className="mt-3 space-y-6">
					<TitleAndTagline />
					<SapCtas />
				</div>

				{topImpactStories.length > 0 && <TopImpactStoriesDesktop />}
			</div>

			{topImpactStories.length > 0 && (
				<TopImpactStoriesMobileProvider>
					<TopImpactStoriesMobile />
				</TopImpactStoriesMobileProvider>
			)}
		</section>
	);
};
